// module.exports = {
// 	name: 'Octopharma - Octopharma web app',
// 	shortName: 'Octopharma',
// 	description: 'Octopharma portal version of the mobile app',
// 	primaryColor: '#253c99',
// 	secondaryColor: '#13a689',
// 	msTileColor: '#253c99'
// }

module.exports = {
	name: 'Octopharma - Media pharma web app',
	shortName: 'Octopharma',
	description: 'Octopharma portal version of the mobile app',
	primaryColor: '#165c31',
	secondaryColor: '#a11c20',
	msTileColor: '#115740'
}

// module.exports = {
// 	name: 'Octopharma - Ibn-alhaytham web app',
// 	shortName: 'Octopharma',
// 	description: 'Octopharma portal version of the mobile app',
// 	primaryColor: '#0b5b6f',
// 	secondaryColor: '#f57f20',
// 	msTileColor: '#0996b9'
// }

// export const logo = require('@/assets/logo-eng (2).png');
// export const drawerLogos = {
//     mini: require('@/assets/brands/ibn-alhaythem-mini.png'),
//     normal: require('@/assets/brands/ibn-alhaythem.png')
// };
// export const colors = {
//     primary: '#',  
//     primaryLight: '#c0dfff',
//     secondary: '#',
//     lightBlue: '#0996b9'
// }
